var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3h-2V2c0-1.094-.906-2-2-2H6C4.875 0 4 .906 4 2v1H2C.875 3 0 3.906 0 5v8c0 1.125.875 2 2 2h12c1.094 0 2-.875 2-2V5c0-1.094-.906-2-2-2zM6 1.5h4c.25 0 .5.25.5.5v1h-5V2c0-.25.219-.5.5-.5zm-4 3h12c.25 0 .5.25.5.5v3h-13V5c0-.25.219-.5.5-.5zm12 9H2a.494.494 0 01-.5-.5V9.5H6v.5c0 .563.438 1 1 1h2c.531 0 1-.438 1-1v-.5h4.5V13c0 .281-.25.5-.5.5z",
    fill: "#005ce6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceFilled);
export default __webpack_public_path__ + "static/media/workspace_filled.85f41f272efca9da2036b0d5da26007a.svg";
export { ForwardRef as ReactComponent };